import { useLocation } from 'react-router-dom';

export const usePathname = ({
  normalize = true,
  fullPath = false,
}: { normalize?: boolean; fullPath?: boolean } = {}): string => {
  const { pathname, search, hash } = useLocation();
  let path = pathname;

  if (normalize) {
    path = path.replace(/\/+$/, '');
  }

  if (fullPath) {
    path = `${path}${search}${hash}`;
  }

  return path;
};
